import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractChartOfAccountsValidationResult from "./AbstractChartOfAccountsValidationResult.js";

/**
 * Error raised when a group is contained in several groups.
 *
 * @param {chartOfAccountsGroup} spec.container - Group already containing the contained
 * @param {chartOfAccountsGroup} spec.contained - Group with two parents
 */
export default class AlreadyInAGroupValidationResult extends AbstractChartOfAccountsValidationResult {
	constructor(spec) {
		super(spec);

		this._container = this._chartOfAccounts.findById(spec.container);
		this._contained = this._chartOfAccounts.findById(spec.contained);
	}

	getContainer() {
		return this._container;
	}

	getContained() {
		return this._contained;
	}

	getMessage() {
		return _('"{container}" can not contain "{contained}"', {
			container: this._container.getName(),
			contained: this._contained.getName(),
		});
	}

	static getType() {
		return "AlreadyInAGroupValidationResult";
	}
}
